import { render, staticRenderFns } from "./Namad.vue?vue&type=template&id=2b8bb1a4&"
import script from "./Namad.vue?vue&type=script&lang=js&"
export * from "./Namad.vue?vue&type=script&lang=js&"
import style0 from "./Namad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports